import produce from 'immer';

// TYPES
import { Types, ExcluirMunicipio } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: ExcluirMunicipio = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirMunicipio {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_MUNICIPIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.EXCLUIR_MUNICIPIO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.EXCLUIR_MUNICIPIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_MUNICIPIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
